/*
 * BidEvaluationTemplates — requires sub-modules (GridOptions, EditorActions,
 * ValidationUtils, Moves, CellRenderers) that have deep Sprockets //= require
 * chains. These cannot be ESM-imported; they are loaded via Sprockets on the
 * v4 layout. On other layouts (intelligence, protenders), these globals are
 * undefined. We wrap in try-catch to prevent crashing the entire IIFE bundle,
 * which would kill CompaniesGridView and other modules below this one.
 */
import $ from 'jquery';

window.BidEvaluationTemplates = {
  _grid: null,
  _gridOptions: null,

  _newRowCount: 0,
  _emptyRowData: {
    name: '',
    category: null,
    type: null,
    weight: null,
    is_leaf: null,
    is_section: null,
    group: [],
    groupSortString: ''
  },

  _initialRowData: {
    id: 'emptyId_initial',
    name: '',
    is_section: true,
    is_leaf: false,
    group: [1],
    groupSortString: '1'
  },

  initializeView(options, key) {
    if (options == null) { options = {}; }
    const gridDiv = $('#bid-evaluation-template-grid')[0];
    this._gridOptions = window.GridOptions.prepare(_.extend(options, { controller: this }));

    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();
    this._grid = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._grid;
    this._resizeHorizontally();

    $(window).resize(_.bind(this._resizeHorizontally, this));
    $('#clear').click(_.bind(this.refresh, this));
    $('#moveLinks').on('click', '#up', () => { if (this._canMoveUp()) { return this._moveUp(); } });
    $('#moveLinks').on('click', '#down', () => { if (this._canMoveDown()) { return this._moveDown(); } });

    if (options.action === 'new') {
      return $('#save-bid-evaluation-template').click(_.bind(this.create, this));
    } else if (options.action === 'edit') {
      $('#bid-evaluation-template-name').val(options.data.name);
      this._calculateAllPercentages();
      return $('#save-bid-evaluation-template').click(_.bind(this.update, this));
    }
  },

  _resizeHorizontally() {
    return this._grid.sizeColumnsToFit();
  },

  refresh() {
    return window.location = window.location;
  },

  create() {
    const data = this._getData();
    return $.ajax({
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ bid_evaluation_template: data }),
      url: '/company_settings/bid_templates/',
      beforeSend: () => {
        this._clearErrors();
        return $('#save-bid-evaluation-template').attr('disabled', 'disabled');
      },
      success(response) { return window.location = response.href; },
      error: xhr => {
        $('#save-bid-evaluation-template').removeAttr('disabled');
        if (xhr.status === 422) {
          return this._markErrors({ errors: xhr.responseJSON.errors });
        }
      }
    });
  },

  update() {
    const data = this._getData();
    const id = $('#bid-evaluation-template').data('id');
    return $.ajax({
      method: 'PATCH',
      contentType: 'application/json',
      data: JSON.stringify({ bid_evaluation_template: data }),
      url: `/company_settings/bid_templates/${id}`,
      beforeSend: () => this._clearErrors(),
      success(response) { return window.location = response.href; },
      error: xhr => {
        if (xhr.status === 422) {
          return this._markErrors({ errors: xhr.responseJSON.errors });
        }
      }
    });
  }
};

// Sub-modules are loaded via Sprockets on v4 layout only.
// Guard the extend calls so they don't crash on other layouts.
try {
  if (window.EditorActions) _.extend(BidEvaluationTemplates, window.EditorActions);
  if (window.ValidationUtils) _.extend(BidEvaluationTemplates, window.ValidationUtils);
  if (window.Moves) _.extend(BidEvaluationTemplates, window.Moves);
} catch (e) {
  console.warn('[BidEvaluationTemplates] sub-module extend:', e.message);
}
